module.exports = __webpack_public_path__ + "img/bottomSlogan.f70346e5.png";